import React from 'react';

const PdfSvgV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
      <path
        d="M7.875 1.0625V2C7.875 2.88375 7.875 3.32562 8.15 3.6C8.42375 3.875 8.86563 3.875 9.75 3.875H10.6875"
        stroke="black"
        strokeWidth="0.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 6.375H8.5M3.5 8.25H8.5M3.5 10.125H6.10625M1 9.5V4.5C1 2.7325 1 1.84812 1.54938 1.29937C2.09813 0.75 2.9825 0.75 4.75 0.75H7.3575C7.6125 0.75 7.74062 0.75 7.85562 0.7975C7.97 0.845 8.06063 0.935 8.24125 1.11625L10.6337 3.50875C10.815 3.69 10.905 3.78 10.9525 3.895C11 4.00938 11 4.1375 11 4.3925V9.5C11 11.2675 11 12.1519 10.4506 12.7006C9.90188 13.25 9.0175 13.25 7.25 13.25H4.75C2.9825 13.25 2.09813 13.25 1.54938 12.7006C1 12.1519 1 11.2675 1 9.5Z"
        stroke="black"
        strokeWidth="0.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PdfSvgV2;
